class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.debouncedOnSubmit = this.debounce(this.onSubmitHandler.bind(this), 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit);
  }

  onSubmitHandler(e) {
    const formData = new FormData(this.querySelector('form'));
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;

    this.renderPage(url);
  }

  renderPage(url) {
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const grid = doc.querySelector('#ProductGridContainer');
        const count = doc.querySelector('#ProductCountDesktop');

        document.querySelector('#ProductGridContainer').innerHTML = grid.innerHTML;
        if (count) document.querySelector('#ProductCountDesktop').innerHTML = count.innerHTML;
      });
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach(element =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
  }

  onRangeChange() {
    this.closest('facet-filters-form').querySelector('form').dispatchEvent(new Event('input'));
  }
}

customElements.define('price-range', PriceRange);
